import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { IconButton, styled } from '@mui/material';
import PropTypes from 'prop-types';
import { SIDEBAR_WIDTH } from '../../constants/layout';

const ToggleIconButton = styled(IconButton, {
  shouldForwardProp: prop => prop !== 'sidebarOpen',
})(({ theme }) => ({
  backgroundColor: 'white',
  position: 'fixed',
  color: '#5A5A5A',
  width: '24px',
  height: '24px',
  left: '12px',
  top: '20px',
  padding: 0,
  zIndex: 1201,
  '&:focus,:hover': {
    backgroundColor: 'white',
  },
  transition: theme.transitions.create('left', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ sidebarOpen }) => sidebarOpen,
      style: {
        transition: theme.transitions.create('left', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        left: `calc(${SIDEBAR_WIDTH}px - 12px)`,
      },
    },
  ],
}));

const SidebarToggleButton = ({ sidebarOpen, handleSidebarToggle }) => {
  return (
    <ToggleIconButton
      aria-label='toggle sidebar visibility'
      className=''
      onClick={handleSidebarToggle}
      sidebarOpen={sidebarOpen}
      sx={{
        displayPrint: 'none',
      }}
    >
      {sidebarOpen ? <ChevronLeft /> : <ChevronRight />}
    </ToggleIconButton>
  );
};

SidebarToggleButton.propTypes = {
  sidebarOpen: PropTypes.bool,
  handleSidebarToggle: PropTypes.func,
};

export default SidebarToggleButton;
